/**
 * Fonte única de família, cor e nome da situação do plantão.
 * O mesmo contrato do admin-v3 e do app do profissional.
 */

export const FAMILIAS = {
  AGENDADO: 'agendado',
  ANDAMENTO: 'andamento',
  CONCLUIDO: 'concluido',
  VALIDADO: 'validado',
  ATRASADO: 'atrasado',
  FALTA: 'falta',
  PENDENTE: 'pendente',
  ENCERRADO: 'encerrado',
  DESCONHECIDO: 'desconhecido',
};

export const NOME_DA_FAMILIA = {
  [FAMILIAS.AGENDADO]: 'Agendado',
  [FAMILIAS.ANDAMENTO]: 'Ocorrendo',
  [FAMILIAS.CONCLUIDO]: 'Realizado',
  [FAMILIAS.VALIDADO]: 'Validado',
  [FAMILIAS.ATRASADO]: 'Atrasado',
  [FAMILIAS.FALTA]: 'Falta',
  [FAMILIAS.PENDENTE]: 'Pendente',
  [FAMILIAS.ENCERRADO]: 'Encerrado',
  [FAMILIAS.DESCONHECIDO]: 'Encerrado',
};

export const CORES = {
  [FAMILIAS.AGENDADO]: { texto: '#44546A', solido: '#5B6B82' },
  [FAMILIAS.ANDAMENTO]: { texto: '#1A56B5', solido: '#2563C9' },
  [FAMILIAS.CONCLUIDO]: { texto: '#07724F', solido: '#0E8A5F' },
  [FAMILIAS.VALIDADO]: { texto: '#055C3F', solido: '#055C3F' },
  [FAMILIAS.ATRASADO]: { texto: '#9A5B08', solido: '#C77A0C' },
  [FAMILIAS.FALTA]: { texto: '#A32E2E', solido: '#C0392B' },
  [FAMILIAS.PENDENTE]: { texto: '#6B3FA0', solido: '#7C4DBF' },
  [FAMILIAS.ENCERRADO]: { texto: '#6F6C68', solido: '#85817C' },
  [FAMILIAS.DESCONHECIDO]: { texto: '#6F6C68', solido: '#85817C' },
};

export const FAMILIAS_DA_LEGENDA = [
  FAMILIAS.AGENDADO,
  FAMILIAS.ANDAMENTO,
  FAMILIAS.CONCLUIDO,
  FAMILIAS.VALIDADO,
  FAMILIAS.ATRASADO,
  FAMILIAS.FALTA,
  FAMILIAS.PENDENTE,
  FAMILIAS.ENCERRADO,
];

export const TROCAS = {
  ENVIADA: 'enviada',
  RECEBIDA: 'recebida',
  NENHUMA: 'nenhuma',
};

export const MARCADORES_DE_TROCA = [
  { troca: TROCAS.ENVIADA, marcador: '↗', nome: 'enviado a outro' },
  { troca: TROCAS.RECEBIDA, marcador: '↙', nome: 'recebido de outro' },
];

const FAMILIA_POR_CODIGO = {
  10: FAMILIAS.FALTA,
  11: FAMILIAS.PENDENTE,
  12: FAMILIAS.AGENDADO,
  13: FAMILIAS.ANDAMENTO,
  14: FAMILIAS.CONCLUIDO,
  15: FAMILIAS.ENCERRADO,
  17: FAMILIAS.PENDENTE,
  18: FAMILIAS.ENCERRADO,
  19: FAMILIAS.ATRASADO,
  21: FAMILIAS.PENDENTE,
  22: FAMILIAS.ENCERRADO,
  23: FAMILIAS.ENCERRADO,
  31: FAMILIAS.PENDENTE,
  32: FAMILIAS.AGENDADO,
  33: FAMILIAS.ANDAMENTO,
  34: FAMILIAS.CONCLUIDO,
  35: FAMILIAS.ENCERRADO,
  38: FAMILIAS.ENCERRADO,
};

const VALIDACAO_CONCLUIDA = 2;
const DEZENA_DA_TROCA_ENVIADA = 2;
const DEZENA_DA_TROCA_RECEBIDA = 3;

export const corDaSituacao = (familia) =>
  CORES[familia] || CORES[FAMILIAS.DESCONHECIDO];

export const nomeDaSituacao = (familia) =>
  NOME_DA_FAMILIA[familia] || NOME_DA_FAMILIA[FAMILIAS.DESCONHECIDO];

export const familiaPeloCodigo = (codigo, validado = false) => {
  const familia = FAMILIA_POR_CODIGO[Number(codigo)] || FAMILIAS.DESCONHECIDO;
  const podeSerValidado = familia === FAMILIAS.CONCLUIDO;
  return validado && podeSerValidado ? FAMILIAS.VALIDADO : familia;
};

export const familiaDaAgenda = (agenda) => {
  const validado = temSinalDeValidacao(agenda);
  const familiaDaApi = agenda?.situation_familia;

  if (!CORES[familiaDaApi]) {
    return familiaPeloCodigo(codigoDaAgenda(agenda), validado);
  }

  // A API não distingue validado em todas as rotas; o painel promove pelos
  // sinais de validação que já lê há tempos.
  const promoveParaValidado = validado && familiaDaApi === FAMILIAS.CONCLUIDO;
  return promoveParaValidado ? FAMILIAS.VALIDADO : familiaDaApi;
};

export const trocaDaAgenda = (agenda) => {
  const dezena = Math.floor(codigoDaAgenda(agenda) / 10);
  if (dezena === DEZENA_DA_TROCA_ENVIADA) return TROCAS.ENVIADA;
  if (dezena === DEZENA_DA_TROCA_RECEBIDA) return TROCAS.RECEBIDA;
  return TROCAS.NENHUMA;
};

const codigoDaAgenda = (agenda) =>
  agenda?.situation_code ??
  Number(`${agenda?.situation}${agenda?.situation_status}`);

const temSinalDeValidacao = (agenda) =>
  agenda?.validated_status === VALIDACAO_CONCLUIDA ||
  !!agenda?.validated_description ||
  !!agenda?.user_validated;
